import { enumSchemaFromDynamicArray } from '@common/neo.tax';
import { Dispatch, SetStateAction } from 'react';
import { z } from 'zod';

import { ColumnDefinition } from '../filter-popover';

export type ColumnVisibilityPersistenceKey =
  | 'ascProjects'
  | 'ascWages'
  | 'rdAccountingQre'
  | 'rdProjects'
  | 'rdPayrollQre';

export type ColumnVisibilityState<ColumnName extends string> = {
  columns: ColumnDefinition<ColumnName>[] | readonly ColumnDefinition<ColumnName>[];
  alwaysVisibleColumns: ColumnName[];
  visibleColumns: ColumnName[];
  setVisibleColumns: Dispatch<SetStateAction<ColumnName[]>>;
  onColumnVisibilityChange: (visibleColumns: ColumnName[]) => void;
};

export const makeColumnVisibilitySchema = <ColumnName extends string>(
  columnNames: ColumnName[],
): z.ZodType<ColumnName[]> => z.array(enumSchemaFromDynamicArray(columnNames));
